'use client';
import styled from 'styled-components';

/**
 * @todo responsiveness - breakpoints
 */
export const SideMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.75rem;
  padding: 0.5rem;
  padding-top: 3.75rem;
  width: 100%;
  position: sticky;
  top: 0;

  @media screen and (max-width: 700px) {
    padding-top: 1.75rem;
    padding: 1rem;
    gap: 1.25rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 5.25rem;
  grid-template-columns: minmax(60%, 1fr) minmax(15rem, 20rem);

  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;
